module.exports = __webpack_public_path__ + "img/apple-touch-icon-76x76.cb6b17cd.png";